import styled from "styled-components";

/**
 * Wrapper do conteúdo principal (Mobile)
 */
export const HeroContentWrapperMobile = styled.div`
  padding: ${({ theme }) => theme.spacing(14)}
    ${({ theme }) => theme.spacing(2)} ${({ theme }) => theme.spacing(4)};
  gap: ${({ theme }) => theme.spacing(2)};
  justify-content: center;
  flex-direction: column;
  align-items: center;
  display: flex;
`;
